import { render, staticRenderFns } from "./ServiceObjectZabbixMonitoringStatus.vue?vue&type=template&id=304e0379&"
import script from "./ServiceObjectZabbixMonitoringStatus.vue?vue&type=script&lang=js&"
export * from "./ServiceObjectZabbixMonitoringStatus.vue?vue&type=script&lang=js&"
import style0 from "./ServiceObjectZabbixMonitoringStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QInput,QField} from 'quasar'
component.options.components = Object.assign({QItem,QInput,QField}, component.options.components || {})
